
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import Swiper from "swiper"
import payPublic from '@/javascript/payPublic'
export default {
props: {
contact:{
type: Array
},
type:{
type: String
},
title:{
type: String
},
count:{
type: Number
}
},
components: {
Checker,
CheckerItem
},
data(){
return {
changeModel: {
radio: 0,
check: [0]
},
name:'',
phone:'',
infoList:[],
len: 0,
fillContent: 1,
maxNum: 0,
initSlideSwiper: {},
initialSlide: 0,
changeType: ''
}
},
mounted(){
const name = this.$route.name

if(name === 'tickethjly' || name === 'ticketqmx' || name === 'ticketslzl' || name === 'hotelReservation'){
const orderInfo = {}
orderInfo.count = this.count
localStorage.setItem('dateObj', JSON.stringify(orderInfo))
}
this.changeType = this.type
let index

if(this.type === 'radio'){
index = this.changeModel['radio']
this.$emit('changeInfoList',this.type,index === '' ? '' : this.contact[index])
}else{
if(this.count === 1){
this.changeType = 'radio'
localStorage.removeItem('multipleSelected')
}else{
this.changeType = 'check'
}
if(this.changeType === 'radio'){
index = this.changeModel['radio']
this.$emit('changeInfoList',this.type,index === '' ? [] : [this.contact[index]])
}else{
index = this.changeModel['check']
const arr = []
if(index === 0){
this.$emit('changeList',this.type,[])
}else{
for(let i=0;i<index.length;i++){
arr.push(this.contact[index[i]])
}
this.$emit('changeInfoList',this.type,arr)
}
}
}
},
watch:{
contact: {
handler(val) {
const _this = this
const fillList = JSON.parse(localStorage.getItem("fillList"))
_this.$nextTick(() => {
_this.initSlideSwiper = new Swiper(".reserve-swiper", {
slidesPerView: 'auto',
initialSlide: this.initialSlide,
slidesOffsetAfter : -8,
})
})
let value
let selected

if(_this.type === 'radio'){

selected = JSON.parse(localStorage.getItem('oneSelected'))
if(selected !== null){

let selectFlag = 0
if(selected.index !== '' && selected.id !== ''){
val.map((item,index) => {
if(item.id === selected.id.id){
selected.index = index
selected.id = val[index]
selectFlag = 1
}
})
if(selectFlag === 0){
selected.index = 0
selected.id = val[0]
}
}
_this.changeModel['radio'] = selected.index
if(fillList){
if(selected.index === ''){
if(fillList.type === 'radio'){
_this.changeModel['radio'] = 0
selected.index = 0
selected.id = val[0]
localStorage.setItem('oneSelected', JSON.stringify(selected))
}
}
}else{
if(selected.index !== 0){
_this.changeModel['radio'] = selected.index
}
}
}
value = _this.changeModel['radio']

}else{
if(this.count === 1){

selected = JSON.parse(localStorage.getItem('changeType'))
if(selected !== null){

let selectFlag = 0
if(selected.index !== '' && selected.id[0].length !== 0){
val.map((item,index) => {
if(item.id === selected.id[0].id){
selected.index = index
selected.id[0] = val[index]
selectFlag = 1
}
})
if(selectFlag === 0){
selected.index = 0
selected.id[0] = val[0]
}
}
_this.changeModel['radio'] = selected.index
if(fillList){
if(selected.index === ''){
if(fillList.type === 'check'){
_this.changeModel['radio'] = 0
selected.index = 0
selected.id[0] = val[0]
localStorage.setItem('changeType', JSON.stringify(selected))
}
}
localStorage.setItem('fillList', false)
}else{
if(selected.index !== 0){
_this.changeModel['radio'] = selected.index
}
}
}
value = _this.changeModel['radio']
}else{
const name = this.$route.name
if(name === 'scienceOrder'){
const orderInfo = {}
orderInfo.count = this.count
localStorage.setItem('dateObj', JSON.stringify(orderInfo))
}
const info = JSON.parse(localStorage.getItem("dateObj"))
selected = JSON.parse(localStorage.getItem('multipleSelected'))

if(selected !== null){

if(selected.index.length !== 0 && selected.id.length !== 0){
const arrIndex = []
const arrIdList = []
for(let p=0;p<val.length;p++){
selected.id.map(item => {
if(item.id === val[p].id){
arrIndex.push(p)
arrIdList.push(val[p])
}
})
}
if(arrIndex.length === 0 && arrIdList.length === 0){
arrIndex.push(0)
arrIdList.push(val[0])
}
selected.index = arrIndex
selected.id = arrIdList
}
_this.changeModel['check'] = selected.index

if(fillList){
if(fillList.type === 'check'){ // 游玩补全信息
selected.index.push(0)
selected.id.push(val[0])
const changeRadio = JSON.parse(localStorage.getItem('oneSelected'))
if(changeRadio !== null){
if(changeRadio !== ''){
const userinfo = {}
userinfo.index = changeRadio + 1
userinfo.id = val[changeRadio + 1]
localStorage.setItem('oneSelected', JSON.stringify(userinfo))
_this.changeModel['radio'] = changeRadio + 1
}
}
}
_this.changeModel['check'] = selected.index
localStorage.setItem('multipleSelected', JSON.stringify(selected))
localStorage.setItem('fillList', false)
}else{
if(selected.index){
_this.changeModel['check'] = selected.index
}
}
}

if(info && info.hasOwnProperty('count') && name !== 'scienceOrder'){
this.maxNum = info.count
}else{
if(name === 'scienceOrder'){
this.maxNum = 0
}else{
this.changeType = 'radio'
}

if(selected !==null && name !== 'scienceOrder'){
if(selected.index.length > 1){
selected.index = [0]
selected.id = val[0]
localStorage.setItem('multipleSelected', JSON.stringify(selected))
_this.changeModel['check'] = selected.index
}
}
}
value = _this.changeModel['check']
}
}
_this.changeInfoList(value,_this,'change')
},
immediate: true
},

count(val,oldVal){
const name = this.$route.name
let that
if(this.$parent.$children.length === 3){
that = this.$parent.$children[2]
that.maxNum = val
const name = ''
const phone = ''
const id = ''
const card = ''
const info = JSON.parse(localStorage.getItem("changeType"))
const mult = JSON.parse(localStorage.getItem("multipleSelected"))
if(val === 1){
that.changeType = 'radio'
const userinfo = {}
userinfo.index = 0
userinfo.id = that.contact[0]
localStorage.setItem('changeType', JSON.stringify(userinfo))
if(val === 1 && oldVal === 2 &&  info.index === ''){
if(mult !== null){
const userinfo = {}
userinfo.index = [mult.index[0]]
userinfo.id = [mult.id[0]]

localStorage.setItem('changeType', JSON.stringify(userinfo))
}
}
localStorage.removeItem('multipleSelected')
}else{
that.changeType = 'check'
if(oldVal === 1 && info.index === ''){
that.changeModel['check'] = []
that.len = 0
}
if(oldVal === 1 && info.index !== ''){
that.changeModel['check'] = [info.index]
that.len = 1
}
const value = that.changeModel['check']
if(val >= that.len){
that.infoList = []
that.fillContent = val - that.len
if(value.length > 0){
that.changeInfoList(value,that,'click')
}
for(let i=0;i<that.fillContent;i++){
that.infoList.push({id,name,card,phone})
}
}else{
that.changeModel['check'].pop()
}
}
}
},
},
methods: {
itemClick(value){
if(this.type === 'check'){
const info = JSON.parse(localStorage.getItem("dateObj"))

if(info && info.hasOwnProperty('count') && info.count !== 1){
const selected = JSON.parse(localStorage.getItem("multipleSelected"))
if(selected !== null){
if(this.maxNum === info.count && this.maxNum === selected.index.length && this.maxNum === value.length){
payPublic.showPrompt(`您只需要添加${this.maxNum}位即可`)
}
}
}
}
},

onChage(value){
const _this = this
const name = this.$route.name
const info = JSON.parse(localStorage.getItem("dateObj"))
let obj = {}
let arr = []
if(this.type === 'check'){

if(this.changeType === 'radio'){
let radioarr = []
if(_this.changeModel['radio'] !== ''){
radioarr = [_this.contact[_this.changeModel['radio']]]
}else{
radioarr = []
}
value = _this.changeModel['radio']
const userinfo = {}
userinfo.index = _this.changeModel['radio']
userinfo.id = radioarr
localStorage.setItem('changeType', JSON.stringify(userinfo))
_this.$emit('changeInfoList',this.type,radioarr)
}else{
if(info && info.hasOwnProperty('count') && name !== 'scienceOrder'){
this.maxNum = info.count
}else{
if(name === 'scienceOrder'){
this.maxNum = 0
}else{
this.maxNum = 1
}
}
value = _this.changeModel['check']

if(value !== ''){
for(let i = 0; i<value.length; i++){
arr.push(this.contact[value[i]])
}
}else{
arr = []
}
const userInfo = {}
userInfo.index = value
userInfo.id = arr
localStorage.setItem('multipleSelected', JSON.stringify(userInfo))
_this.$emit('changeInfoList',this.type,arr)
}
}else{

if(value !== ''){
obj = this.contact[value]
}else{
obj = ''
}
_this.$emit('changeInfoList',this.type,obj)
const userinfo = {}
userinfo.index = value
userinfo.id = this.contact[value] || ''
localStorage.setItem('oneSelected', JSON.stringify(userinfo))
}
_this.changeInfoList(value,_this,'change')
},

changeInfoList(value,self,from){
let name = ''
let phone = ''
let id = ''
let idCard = ''
if(self.type === 'radio'){
if(value !== '' && self.contact.length !== 0){
self.infoList = []
id = self.contact[value].id
name = self.contact[value].name
phone = self.contact[value].phone
idCard = self.contact[value].idCard
self.infoList.push({id,name,idCard,phone})
}else{
self.infoList = []
id = ''
name = ''
idCard = ''
phone = ''
self.infoList.push({id,name,idCard,phone})
}
}else{
if(this.changeType === 'radio'){
if(value !== '' && self.contact.length !== 0){
self.infoList = []
id = self.contact[value].id
name = self.contact[value].name
phone = self.contact[value].phone
idCard = self.contact[value].idCard
self.infoList.push({id,name,idCard,phone})
}else{
self.infoList = []
id = ''
name = ''
idCard = ''
phone = ''
self.infoList.push({id,name,idCard,phone})
}
}else{
const info = JSON.parse(localStorage.getItem("dateObj"))
let countNum = 1
if(info && info.hasOwnProperty('count')){
countNum = info.count
}
if(value.length > 0 && self.contact.length !== 0){
self.infoList = []
for(let i=0; i<value.length;i++){
id = self.contact[value[i]].id
name = self.contact[value[i]].name
phone = self.contact[value[i]].phone
idCard = self.contact[value[i]].idCard
self.infoList.push({id,name,idCard,phone})
}
if(countNum >= value.length && from === 'change'){
const filllength = countNum - value.length
id = ''
name = ''
phone = ''
idCard = ''
for(let j=0;j<filllength;j++){
self.infoList.push({id,name,idCard,phone})
}
}
}else{
self.infoList = []
if(from === 'change'){
for(let i=0;i<countNum;i++){
id = ''
name = ''
phone = ''
idCard = ''
self.infoList.push({id,name,idCard,phone})
}
}
}
self.len = value.length
}
}
},

addReplace(){

const orderInfo = JSON.parse(localStorage.getItem("dateObj"))
if(this.type === 'radio'){

if(this.changeModel['radio'] !== ''){
orderInfo.bookInfo = {
order: this.changeModel['radio'],
id: this.contact[this.changeModel['radio']].id
}
}else{
orderInfo.bookInfo = false
}
localStorage.setItem('dateObj', JSON.stringify(orderInfo))
}else{

if(this.count === 1){
if(this.changeModel['radio'] === ''){
orderInfo.changeIndex = -1
orderInfo.playPeople = []
}else{
orderInfo.changeIndex = this.changeModel['radio']
orderInfo.playPeople = [this.contact[this.changeModel['radio']]]
}
}else{
let arr = []
for(let i=0;i<this.changeModel['check'].length;i++){
arr.push(this.contact[this.changeModel['check'][i]])
}
orderInfo.playPeople = arr
orderInfo.playIndex = this.changeModel['check']
}
localStorage.setItem('dateObj', JSON.stringify(orderInfo))
}
this.$emit('addReplace',this.type,this.changeType)
},

add(){
this.$router.push({ path:'/addContact', query: { contactNum: this.contact.length, type: this.type }})
},

edit(item){
let info = {}
info = item
this.$router.push({
path: '/addContact',
query: {
objData: JSON.stringify(info),
tabIndex: 1
}
})
},

deleteData(item,index){
if(this.type === 'radio'){
this.infoList = []
const id = ''
const name = ''
const phone = ''
const idCard = ''
this.infoList.push({id,name,idCard,phone})
this.changeModel['radio'] = ''
}else{
if(this.changeType === 'radio'){
this.infoList = []
const id = ''
const name = ''
const phone = ''
const idCard = ''
this.infoList.push({id,name,idCard,phone})
this.changeModel['radio'] = ''
}else{
this.infoList.splice(index,1)
for(let i=0;i<this.contact.length;i++){
if(this.contact[i].name === item.name){
const idx = this.changeModel['check'].indexOf(i)
this.changeModel['check'].splice(idx,1)
}
}
}
}
},

changeList(val,type,changeType){
this.initialSlide = 1
if(type === 'radio'){
this.changeModel['radio'] = val.bookInfo.order
if(this.initSlideSwiper.length){
this.initSlideSwiper[0].slideTo(val.bookInfo.order, 1000, false)
}else{
this.initSlideSwiper.slideTo(val.bookInfo.order, 1000, false)
}
}else{
if(changeType === 'radio'){
let that
if(this.$parent.$children.length === 4){
that = this.$parent.$children[2]
that.initialSlide = 1
that.changeModel['radio'] = val.changeIndex
if(that.initSlideSwiper.length){
that.initSlideSwiper[1].slideTo(val.changeIndex, 1000, false)
}else{
that.initSlideSwiper.slideTo(val.changeIndex, 1000, false)
}
}
}else{
this.initialSlide = 1
this.changeModel['check'] = val.playIndex
if(this.initSlideSwiper.length){
this.initSlideSwiper[1].slideTo(val.playIndex[0], 1000, false)
}else{
this.initSlideSwiper.slideTo(val.playIndex[0], 1000, false)
}
}
}
}
},
}
